import { businessPlanAxios } from 'services/controllers/businessPlan';

import { IPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';

import * as t from './types';

export const PersonalExpensesApi = {
  getPersonalExpensesCalculationsByCategory: async (params: t.IGetPersonalExpensesCalculationsParams) => {
    const { businessPlanId, unit, personalExpenseData } = params;
    const { data } = await businessPlanAxios.put<t.IGetPersonalExpensesCalculationResponse>(
      `/${businessPlanId}/personalexpense/${unit}`,
      personalExpenseData
    );
    return data;
  },
  
  sentPersonalExpensesByProduct: async ({ businessPlanId, unit, expensesByProductBody }: t.IGetPersonalExpensesCalculationsByProductParams) => {
    const { data } = await businessPlanAxios.put<IPeriodsTableRow>(
      `/${businessPlanId}/product/update/detailexpense/${unit}`,
      expensesByProductBody
    );
    return data;
  },
};

